import { ColumnType, ListingHelper } from 'src/app/core/utils/listing.helper';

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'shared-campaign-listing',
  templateUrl: './campaign-listing.component.html',
  styleUrls: ['./campaign-listing.component.scss'],
  host: { class: 'campaign-listing' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedCampaignListingComponent {
  @Input() campaign!: any;
  @Input() disableProgressLine = false;
  @Input() showProgress = true;
  @Input() showColumnHeaders = true;
  @Input() expandable = true;

  @Input() get showOwner() {
    return this.columnBuilder.isShown('owner');
  }
  set showOwner(value: boolean) {
    this.columnBuilder.setShown('owner', value);
  }

  @Input() get showDate() {
    return this.columnBuilder.isShown('date');
  }
  set showDate(value: boolean) {
    this.columnBuilder.setShown('date', value);
  }

  @Input() get showStatus() {
    return this.columnBuilder.isShown('status');
  }
  set showStatus(value: boolean) {
    this.columnBuilder.setShown('status', value);
  }

  @Input() get showOrganization() {
    return this.columnBuilder.isShown('organization');
  }
  set showOrganization(value: boolean) {
    this.columnBuilder.setShown('organization', value);
  }

  columnBuilder = new ListingHelper();

  constructor() {
    this.columnBuilder.addColumn('image', ColumnTypes.Small, true);
    this.columnBuilder.addDefaultColumn('default');
    this.columnBuilder.addColumn('organization', ColumnTypes.Medium);
    this.columnBuilder.addColumn('owner', ColumnTypes.Medium);
    this.columnBuilder.addColumn('date', ColumnTypes.Medium);
    this.columnBuilder.addColumn('status', ColumnTypes.Small);
  }
}
class ColumnTypes {
  static readonly Small: ColumnType = new ColumnType(5, 9);
  static readonly Medium: ColumnType = new ColumnType(10, 25);
  static readonly Large: ColumnType = new ColumnType(15, 25);
}
